// define a mixin object
import enumsJson from '@/data/json/enums/enums.json'
export const EnumBaseMixin = {
  methods: {
    getKey(enumObject, enumValue) {
      try {
        // load required module
        var eObj = require('./' + enumObject)
        // get key from value
        return Object.keys(eObj[enumObject]).find(
          key => eObj[enumObject][key] === enumValue
        )
      } catch (e) {
        return enumValue
      }
    },
    getEnumsContent: function(enumName, enumValue) {
      return this.$cmsService.getContent(
        enumsJson.data,
        enumName + '_' + this.getKey(enumName, enumValue)
      )
    }
  }
}
